<template>
    <div class="col-sm-12 editor-form">
        <h2 class="editor-header">{{ $t('work_time.edit') }}</h2>
      <div class="col-sm-12 form-data nopads">
        <div class="row nopads">
          <div class="col-sm-6 nopads">
            <span class="span-title">{{ $t('work_time.start') }}</span>
            <date-time-picker
              id="start"
              v-model:date="recordUpdate.approved_start_time"
              class="datetime-routa"
              format="dd.MM.yyyy HH:mm"
              :enableTimePicker="true"
              :placeholder="$t('observations_videos.search_input_format')"
            />
          </div>
          <div class="col-sm-6 nopads pl-2">
            <span class="span-title">{{ $t('work_time.end') }}</span>
            <date-time-picker
              id="end"
              v-model:date="recordUpdate.approved_end_time"
              class="datetime-routa"
              format="dd.MM.yyyy HH:mm"
              :enableTimePicker="true"
              :placeholder="$t('observations_videos.search_input_format')"
            />
          </div>
        </div>

        <div class="row nopads">
          <!-- Shift -->
          <div class="col-sm-6 nopads">
            <span class="span-title">{{ $t('work_shift.shift') }}</span>
              <select
                  id="shift"
                  v-model="shift"
                  class="form-select form-select-sm mb-1 no-margin"
                  :disabled="!vehicles || vehicles.length < 1"
              >
                  <option
                      :value="null"
                      disabled
                  >
                      {{ $t('work_time.select_vehicle') }}
                  </option>
                  <option
                      v-for="item in shifts"
                      :key="item.value"
                      :value="item.value"
                  >
                      {{ item.text }}
                  </option>
              </select>
          </div>
          <!-- Vehicle -->
          <div class="col-sm-6 nopads pl-2">
            <span class="span-title">{{ $t('trip_list.vehicle') }}</span>
            <select
              id="vehicle"
              v-model="vehicle"
              class="form-select form-select-sm mb-1"
              :disabled="!vehicles || vehicles.length < 1"
            >
                <option
                  :value="null"
                  disabled
                >
                  {{ $t('work_time.select_vehicle') }}
                </option>
              <option
                v-for="item in vehicles"
                :key="item.id"
                :value="item.id"
              >
                {{ item.make }} {{ item.vehicle_model }} - {{ item.license_plate }}
              </option>
            </select>
          </div>
        </div>

        <div class="row nopads">
          <div class="col-sm-6 nopads">
            <span class="span-title">{{ $t('work_time.mode') }}
            </span>
            <select
              id="mode"
              v-model="workTimeMode"
              :disabled="workTimeModes.length < 1"
              class="form-select form-select-sm no-margin"
            >
                <option
                    :value="null"
                    disabled
                >
                    {{ $t('work_time.select_vehicle') }}
                </option>
                <option
                    v-for="item in workTimeModes"
                    :key="item.value"
                    :value="item.value"
                >
                    {{ item.text }}
                </option>
            </select>
          </div>
          <div class="col-sm-6 nopads pl-2">
            <span class="span-title">{{ $t('work_time.cost_center') }}</span>
            <select
              id="costCenter"
              v-model="costCenter"
              :disabled="costCenters.length < 1"
              class="form-select form-select-sm no-margin"
            >
                <option
                    :value="null"
                    disabled
                >
                    {{ $t('work_time.select_vehicle') }}
                </option>
                <option
                    v-for="item in costCenters"
                    :key="item.value"
                    :value="item.value"
                >
                    {{ item.text }}
                </option>
            </select>
          </div>
        </div>

        <open-order-filter
          :to="recordUpdate.approved_end_time"
          :from="recordUpdate.approved_start_time"
          :order="recordUpdate.order"
          @loading="setLoading"
          @loading-completed="loadingDone"
        />


        <div class="col-sm-12 nopads">
          <span class="span-title">{{ $t('work_time.note') }}</span>
          <textarea
            id="info"
            v-model="recordUpdate.note"
            :placeholder="$t('work_time.note')"
            class="form-control"
            :rows="4"
          />
        </div>
        <div class="col-sm-12 button-container">
          <button class="btn btn-secondary form-button" @click.stop="$emit('close')">
            {{ $t('common.cancel') }}
          </button>
          <button class="btn btn-success form-button" :disabled="loading" @click.stop="submitWorkTimeRecord">
            {{ $t('common.save') }}
          </button>
        </div>
      </div>
      <div
            v-if="loading"
            id="loader"
            class="spinner"
      />
  </div>
</template>

<script>
import {workManagementHelper} from '../mixins/WorkManagementMixin'
import {restApi} from '../mixins/RestApiMixin'
import OpenOrderFilter from "../order/OpenOrderFilter";
import DateTimePicker from "@/components/common/DateTimePicker";
import {inject} from "vue";

export default {
    name: 'WorkTimeEditor',
    components: {OpenOrderFilter, DateTimePicker},
    mixins: [workManagementHelper, restApi],
    props: {
        workTimeRecord: {
            type: Object,
            default: null
        }
    },
    setup() {
        // Inject parents alerter
        const showAlert = inject('showAlert');
        return { showAlert };
    },
    data: function () {
        return {
            workTimeModes: [],
            workTimeMode: null,
            costCenters: [],
            costCenter: null,
            vehicles: [],
            vehicle: null,
            loading: false,
            shift: null,
            shifts: [
                {value: null, text: this.$t('work_shift.select_shift')},
                {value: 1, text: this.$t('work_shift.day_shift')},
                {value: 2, text: this.$t('work_shift.morning_shift')},
                {value: 3, text: this.$t('work_shift.evening_shift')},
                {value: 4, text: this.$t('work_shift.night_shift')}
            ],
            recordUpdate: this.formatItem(this.workTimeRecord)
        }
    },

    watch: {
        workTimeMode: function () {
            if (this.workTimeMode !== this.workTimeRecord.mode.id) {
                this.costCenter = undefined
            }
        }
    },

    mounted: function () {
        this.fetchModes()
        this.fetchCostCenters()
        this.fetchVehicles()
        if (this.workTimeRecord.cost_center) {
            this.costCenter = this.workTimeRecord.cost_center.id
        }
        if (this.workTimeRecord.mode) {
            this.workTimeMode = this.workTimeRecord.mode.id
        }
        if (this.workTimeRecord.shift) {
            this.shift = this.workTimeRecord.shift
        }
        if (this.workTimeRecord.vehicle) {
            this.vehicle = this.workTimeRecord.vehicle.id
        }
    },

    methods: {
        fetchModes: function () {
            this.workTimeModes = []
            this.loading = true
            this.restFetchParams(this.workTimeModeUrl, {company: this.workTimeRecord.mode.company.id}, this.handleModeResponse)
        },

        handleModeResponse: function (response) {
            this.loading = false
            if (response && response.data) {
                response.data.forEach(function (item) {
                    this.workTimeModes.push({value: item.id, text: item.name})
                }, this)
            }
        },

        fetchCostCenters: function () {
            this.costCenters = []
            this.loading = true
            this.restFetchParams(this.costCenterUrl, {company: this.workTimeRecord.mode.company.id}, this.handleCcResponse)
        },

        handleCcResponse: function (response) {
            this.loading = false
            if (response && response.data) {
                response.data.forEach(function (item) {
                    this.costCenters.push({value: item.id, text: item.name})
                }, this)
            }
        },

        fetchVehicles: function () {
            this.loading = true
            this.vehicles = []
            this.restFetch(this.vehicleUrl, this.handleVehicles)
        },

        handleVehicles: function (response) {
            if (response && response.data) {
                this.vehicles = response.data
                if (this.vehicle) {
                    let exists = this.vehicles.find(item => item.id === this.vehicle)
                    if (!exists) {
                        this.vehicle = null
                    }
                }
            }
            this.loading = false
        },

        formatItem: function (item) {
            let copyObj = this.jsonToItem(item)
            copyObj.approved_start_time = item.approved_start_time ? item.approved_start_time + 'Z' : item.approved_start_time // Add 'Z' to show date in local timezone
            copyObj.approved_end_time = item.approved_end_time ? item.approved_end_time + 'Z' : item.approved_end_time
            return copyObj
        },

        submitWorkTimeRecord: function () {
            this.recordUpdate.mode = {id: this.workTimeMode}
            if (this.costCenter) {
                this.recordUpdate.cost_center = {id: this.costCenter}
            } else {
                this.recordUpdate.cost_center = undefined
            }
            if (this.vehicle) {
                this.recordUpdate.vehicle = {id: this.vehicle}
            }
            if (this.shift) {
                this.recordUpdate.shift = this.shift
            }
            var json = this.jsonToItem(this.recordUpdate)
            if (json !== undefined) {
                if (!json.approved_start_time) {
                    this.showAlert(this.$t('work_time.invalid_start_time'))
                    return undefined
                }
                if (!json.approved_end_time || !this.isValidEndTime(json.approved_start_time, json.approved_end_time)) {
                    this.showAlert(this.$t('work_time.invalid_end_time'))
                    return undefined
                }
                this.loading = true
                this.restUpdate(this.workTimeUrl, json, this.success, this.fail)
            }
        },
        isValidEndTime: function (startTime, endTime) {
            return new Date(startTime).getTime() < new Date(endTime).getTime()
        },
        success: function () {
            this.$emit('closeAndUpdate')
            this.loading = false
        },
        fail: function () {
            this.showAlert(this.$t('common.alert_update_failed'))
            this.loading = false
        },
        setOrder: function (order) {
            this.recordUpdate.order = {id: order.id}
        },
        setLoading: function () {
            this.loading = true
        },
        loadingDone: function () {
            this.loading = false
        }
    }
}
</script>
